export const getAnswerRenderSurface = ({
    isActive = false,
    isThin = false,
    isTitle = false,
    postLens = false,
    chatRun = null,
} = {}) => {
    if (isActive) {
        if (isTitle) return 'active-title'
        // dm_chat rows: a run's first message carries the byline, the rest only
        // their body, and the grouping flips as neighbours come and go.
        if (chatRun) return `active-chat-${chatRun}`
        return postLens ? 'active-reply-card' : 'active'
    }
    if (isThin) return 'thin'
    // stream_reply_cards: a known-empty branch title renders in post-lens (reply) anatomy —
    // a different height than the bold-title presentation, so it must not share remembered
    // measurements with it. The presentation flips when the branch gains/loses its first
    // reply, which leaves the title's content signature unchanged.
    if (isTitle) return postLens ? 'stream-title-post' : 'stream-title'
    return 'stream'
}

// Stream-title measurements include card chrome such as the title/reply divider. Bump this
// whenever that chrome changes so persisted measurements cannot override the updated estimate.
export const ANSWER_HEIGHT_LAYOUT_VERSION = 4

// The remembered-height key's revision term is a CONTENT signature, not the answer's updated_at. A
// QuestChannel "update quest" fan-out touches the parent answer (bumps updated_at WITHOUT changing
// content); when updated_at was the revision term, a touched row that had scrolled out and back re-mounted
// with a new key, missed its remembered measured height, and fell back to the undershooting estimate for a
// frame — the on-screen height "flap" jitter (worst on scroll-up). A content signature (see
// answerHeightContentSignature) is stable across a touch but still changes on a genuine edit, so remembered
// heights survive touches while edits correctly invalidate.
const normalizedContentSignature = contentSignature =>
    contentSignature ? String(contentSignature) : 'none'

export const answerHeightKey = (
    answerId,
    {
        width = 0,
        isActive = false,
        isThin = false,
        isTitle = false,
        postLens = false,
        textIsCollapsed = false,
        contentSignature = null,
        chatRun = null,
    } = {},
) =>
    `v${ANSWER_HEIGHT_LAYOUT_VERSION}:${answerId}:${getAnswerRenderSurface({
        isActive,
        isThin,
        isTitle,
        postLens,
        chatRun,
    })}:${textIsCollapsed ? 'collapsed' : 'expanded'}:${normalizedContentSignature(
        contentSignature,
    )}:${Math.round(Number(width || 0) / 50)}`

export const answerHeightKeyPrefix = (
    answerId,
    {
        isActive = false,
        isThin = false,
        isTitle = false,
        postLens = false,
        textIsCollapsed = false,
        contentSignature = null,
        chatRun = null,
    } = {},
) =>
    `v${ANSWER_HEIGHT_LAYOUT_VERSION}:${answerId}:${getAnswerRenderSurface({
        isActive,
        isThin,
        isTitle,
        postLens,
        chatRun,
    })}:${textIsCollapsed ? 'collapsed' : 'expanded'}:${normalizedContentSignature(
        contentSignature,
    )}:`
